module.exports = __webpack_public_path__ + "img/media_slide1.a3de1ddc.jpg";